import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";

import { drawerItemsMain } from "./AdminDrawerItemsMain";
import AdminDashboard from "../../screens/AdminDashboard";
import CreateOrganizationalUserNavigate from "../../screens/AdminOrganizationalUsersNavigate";
import AdminOrganizationalUsers from "../../screens/AdminOrganizationalUsers";
import UpdateAdminOrganizationUser from "../modules/UpdateAdminOrganizationUser";
import CreateAdminOrganizationUser from "../modules/CreateAdminOrganizationUser";
import AdminSettingScreen from "../../screens/AdminSettingScreen";
import AdminOrganizations from "../../screens/AdminOrganizations";
import AdminOrganizationalNavigate from "../../screens/AdminOrganizationalNavigate";
import CreateAdminOrganizations from "../modules/CreateAdminOrganizations";
import UpdateAdminOrganizations from "../modules/UpdateAdminOrganizations";
import AdminCustomDrawerContent from "../../../../components/custom/AdminCustomDrawerContent";

const Drawer = createDrawerNavigator();

export default function AdminDrawerNavigator() {
  const dimensions = useWindowDimensions();

  return (
    <Drawer.Navigator
      initialRouteName="Home"
      screenOptions={{
        drawerStyle: {
          width: 180,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <AdminCustomDrawerContent drawerItems={drawerItemsMain()} {...props} />
      )}
    >
      <Drawer.Screen
        name="AdminDashboard"
        component={AdminDashboard}
        options={{ title: "Dashboard" }}
      />
      <Drawer.Screen
        name="AdminOrganizations"
        component={AdminOrganizations}
        options={{ title: "Organizations" }}
      />

      <Drawer.Screen
        name="AdminOrganizationalUsers"
        component={AdminOrganizationalUsers}
        options={{ title: "Organizational Users" }}
      />

      <Drawer.Screen
        name="AdminOrganizationalUsersNavigate"
        component={CreateOrganizationalUserNavigate}
        options={{ title: "Navigate Admin Organizational Users" }}
      />

      <Drawer.Screen
        name="AdminOrganizationalNavigate"
        component={AdminOrganizationalNavigate}
        options={{ title: "Navigate Admin Organizations" }}
      />

      <Drawer.Screen
        name="UpdateAdminOrganizationUser"
        component={UpdateAdminOrganizationUser}
        options={{ title: "Update Admin Organizational Users" }}
      />

      <Drawer.Screen
        name="AddAdminOrganizationUser"
        component={CreateAdminOrganizationUser}
        options={{ title: "Add Admin Organizational Users" }}
      />

      <Drawer.Screen
        name="AddAdminOrganizations"
        component={CreateAdminOrganizations}
        options={{ title: "Add Admin Organizations" }}
      />

      <Drawer.Screen
        name="UpdateAdminOrganizations"
        component={UpdateAdminOrganizations}
        options={{ title: "Update Admin Organizations" }}
      />

      <Drawer.Screen
        name="AdminSetting"
        component={AdminSettingScreen}
        options={{ title: "Admin Setting" }}
      />
    </Drawer.Navigator>
  );
}
